import { CheckCircle } from "@phosphor-icons/react";

export const ModelBadge = ({ song }) => {
  if (!song?.model) return null;
  const label = song.model.replace("_", " ");
  return (
    <span className="inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full bg-white/5 text-white/70" title="Model sent to Suno · engine Suno actually used" data-testid={`model-badge-${song.id}`}>
      {label}
      {song.suno_model_name && (<><CheckCircle size={10} weight="fill" className="text-green-400" /><span className="text-white/40">{song.suno_model_name}</span></>)}
    </span>
  );
};
